/* eslint max-classes-per-file: 0 */

import {
  Session,
  Subject,
  Procedure,
  Event,
  CollectorPublication as Data,
  CollectorPublicationCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { Fabric } from '@/store/createCrudModule'
import { PublicationsAdapter } from './PublicationsAdapter'
import { SubjectsAdapter } from './SubjectsAdapter'
import { SessionsAdapter } from './SessionsAdapter'
import { ProceduresAdapter } from './ProceduresAdapter'
import { EventsAdapter } from './EventsAdapter'
import get from 'lodash/get'


export const fabric = Fabric<Data, Collection>()

type S = PublicationsState
type G = PublicationsGetters
type M = PublicationsMutations
type A = PublicationsActions


export class PublicationsState extends fabric.State {
  public sessions: Session[] | null = [];

  public subjects: Subject[] | null = [];

  public procedures: Procedure[] | null = [];

  public events: Event[] | null = [];
}

export class PublicationsGetters extends fabric.Getters<S> {
}

export class PublicationsMutations extends fabric.Mutations<S> {
  public setSessions(payload?: Session[]) {
    this.state.sessions = payload || []
  }

  public setSubjects(payload?: Subject[]) {
    this.state.subjects = payload || []
  }

  public setProcedures(payload?: Procedure[]) {
    this.state.procedures = payload || []
  }

  public setEvents(payload?: Event[]) {
    this.state.events = payload || []
  }
}

export class PublicationsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new PublicationsAdapter();

  protected readonly subjectsAdapter = new SubjectsAdapter();

  protected readonly sessionsAdapter = new SessionsAdapter();

  protected readonly proceduresAdapter = new ProceduresAdapter();

  protected readonly eventsAdapter = new EventsAdapter();

  protected readonly idName = 'publication_id';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fetchSessions(...args: any[]) {
    return this.sessionsAdapter.api.getAll({
      event_id: get(args, '[0].form.event_id'),
      pageSize: 250,
    }).then((result) => this.mutations.setSessions(result.data))
  }

  public fetchSubjects() {
    return this.subjectsAdapter.api.getAll({ pageSize: 250 }).then((result) => this.mutations.setSubjects(result.data))
  }

  public fetchProcedures(...args: any[]) {
    return this.proceduresAdapter.api.getAll({
      event_id: get(args, '[0].form.event_id', null),
      session_id: get(args, '[0].form.session_id', null),
      pageSize: 250,
    }).then((result) => this.mutations.setProcedures(result.data))
  }

  public fetchEvents() {
    return this.eventsAdapter.api.getAll({ pageSize: 250 }).then((result) => this.mutations.setEvents(result.data))
  }
}
